import api from "./axios";

export const getPublishedNews = async (limit = 50) => {
  const response = await api.get("/content/news", { params: { limit } });
  return response.data;
};

export const getNewsBySlug = async (slug) => {
  const response = await api.get(`/content/news/${encodeURIComponent(slug)}`);
  return response.data;
};

export const getPublishedTutorials = async () => {
  const response = await api.get("/content/tutorials");
  return response.data;
};

export const getSiteContent = async () => {
  const response = await api.get("/content/site");
  return response.data;
};
